import { createSignal, untrack } from "solid-js";

const [confirmRequest, setConfirmRequest] = createSignal(null);

/**
 * Show a confirmation dialog and resolve once the user responds. Callable from
 * anywhere, including non-component code (e.g. ProseMirror commands), since the
 * underlying store is module-level.
 * @param {string} message The prompt shown to the user
 * @param {{ title?: string, confirmLabel?: string, cancelLabel?: string, variant?: string }} [opts] Dialog options
 * @returns {Promise<boolean>} Whether the user confirmed
 */
export function confirm(message, opts = {}) {
  return new Promise((resolve) => {
    const pending = untrack(confirmRequest);
    if (pending) pending.resolve(false);

    setConfirmRequest({
      message,
      title: opts.title,
      confirmLabel: opts.confirmLabel,
      cancelLabel: opts.cancelLabel,
      variant: opts.variant,
      resolve,
    });
  });
}

/**
 * Resolve the active confirmation request and close the dialog. No-op if there
 * is no pending request, which makes it safe to call from both the accept path
 * and the dialog's own close event.
 * @param {boolean} accepted Whether the user confirmed
 * @returns {void}
 */
export function resolveConfirm(accepted) {
  const request = confirmRequest();
  if (!request) return;
  setConfirmRequest(null);
  request.resolve(accepted);
}

export { confirmRequest };
